module.exports = __webpack_public_path__ + "img/IMG_8673_L_Black.e466d1e3.jpg";